import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { login } from "../redux/actionCreator";
import { toast } from "react-toastify";
import { login_loading } from "../redux/commonReducer";
import { Spinner } from "react-bootstrap";

export default function AdminLogin({ setAdmin, onMfa }) {
  const pwdInput = useRef();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const loading = useSelector(login_loading);

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const handleSubmit = (e) => {
    e?.preventDefault();
    if (username?.trim() == "" || password?.trim() == "") {
      toast.error("Please enter email and password", {
        position: "bottom-center",
        autoClose: 3000,
      });
    } else {
      const data = { email: username, password: password };
      dispatch(
        login(data, (result) => {
          // Three shapes: true | false | { mfa: <challenge> }
          if (result && typeof result === "object" && result.mfa) {
            onMfa && onMfa(result.mfa);
            return;
          }
          if (result === true) {
            navigate("/dashboard");
            toast.success("Login successfully", {
              position: "bottom-center",
              autoClose: 3000,
            });
          }
        })
      );
    }
  };

  const onUsernamekeyPress = (e) => {
    if (e.key == "Enter") {
      pwdInput.current.focus();
    }
  };

  const onEnterLogin = (e) => {
    if (e.key == "Enter") {
      handleSubmit();
    }
  };
  return (
    <div className="admin__login">
      <h2>Admin Login</h2>
      <input
        id="username"
        type="text"
        autocomplete="false"
        className="form-control"
        placeholder="Username"
        onChange={(e) => setUsername(e.target.value)}
        value={username}
        autoComplete="off"
        onKeyDown={(e) => onUsernamekeyPress(e)}
      />
      <input
        id="password"
        type="password"
        autocomplete="new-password"
        className="form-control"
        placeholder="Password"
        ref={pwdInput}
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        autoComplete="off"
        onKeyDown={(e) => onEnterLogin(e)}
      />
      <button
        className="btn-primary cl
            w-50"
        onClick={(e) => handleSubmit(e)}
      >
        {loading ? (
          <Spinner animation="border" role="status" size="sm"></Spinner>
        ) : (
          "Login"
        )}
      </button>
      <div className="mt-3">
        <Link onClick={() => setAdmin(false)} className="admin_login w-100">
          Back to login
        </Link>
      </div>
    </div>
  );
}
